import React from "react";
import { motion } from "framer-motion";
import "../styles/DashboardShowcase.css";



import dashboardImage from "../../../assets/dashboard-preview.png";
import AttendanceShowcase from "./AttendanceShowcase";
import PayrollShowcase from "./PayrollShowcase";
import Navbar from "../Navbar";

const DashboardShowcase = () => {
  return (

     <>
      <Navbar />
    <motion.section
      className="dashboard-showcase-section"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 1 }}
      viewport={{ once: true }}
    >

      {/* LEFT SIDE */}

      <motion.div
        className="dashboard-showcase-left"
        initial={{ opacity: 0, x: -80 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >

        <p className="dashboard-showcase-mini-title">
          REAL-TIME WORKFORCE INSIGHTS
        </p>

        <h2 className="dashboard-showcase-title">
          Powerful Dashboard <br />
          Built for Enterprise Operations
        </h2>

        <p className="dashboard-showcase-description">
          Monitor employee activities, approvals, attendance,
          payroll workflows, reimbursements, and performance metrics
          from one intelligent centralized dashboard.
        </p>

        <div className="dashboard-showcase-points">

          <motion.div
            className="dashboard-point-card"
            whileHover={{ scale: 1.03 }}
          >
            <span>✓</span>
            Live Employee Analytics
          </motion.div>

          <motion.div
            className="dashboard-point-card"
            whileHover={{ scale: 1.03 }}
          >
            <span>✓</span>
            Payroll & Attendance Insights
          </motion.div>

          <motion.div
            className="dashboard-point-card"
            whileHover={{ scale: 1.03 }}
          >
            <span>✓</span>
            Leave & Workflow Monitoring
          </motion.div>

          <motion.div
            className="dashboard-point-card"
            whileHover={{ scale: 1.03 }}
          >
            <span>✓</span>
            Real-Time Approval Tracking
          </motion.div>

        </div>

      </motion.div>

      {/* RIGHT SIDE */}

      <motion.div
        className="dashboard-showcase-right"
        initial={{ opacity: 0, x: 80 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.9 }}
        viewport={{ once: true }}
      >

        <motion.div
          className="dashboard-preview-wrapper"
          animate={{
            y: [0, -10, 0],
          }}
          transition={{
            duration: 5,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        >

          <img
            src={dashboardImage}
            alt="dashboard"
            className="dashboard-preview-image"
          />

          {/* FLOATING CARD 1 */}

          <motion.div
            className="floating-analytics-card analytics-card-1"
            animate={{
              y: [0, -8, 0],
            }}
            transition={{
              duration: 4,
              repeat: Infinity,
            }}
          >

            {/* <h4>Attendance Rate</h4> */}
             <h4 style={{ color: "black" }}>Attendance Rate</h4>

            <span style={{ color: "#55ff60" }}>98.6%</span>

          </motion.div>

          {/* FLOATING CARD 2 */}

          <motion.div
            className="floating-analytics-card analytics-card-2"
            animate={{
              y: [0, 8, 0],
            }}
            transition={{
              duration: 5,
              repeat: Infinity,
            }}
          >

            <h4 style={{ color: "black" }}>Leave Requests</h4>

          <span style={{ color: "#55ff60" }}>128 Approved</span>

          </motion.div>

        </motion.div>

      </motion.div>

    </motion.section>
    <AttendanceShowcase />
     <PayrollShowcase />

    </>
  );
};

export default DashboardShowcase;